import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import './index.style.less';
import ListEmptyResult from '@crema/core/AppList/ListEmptyResult';
import AppGrid from '@crema/core/AppGrid';
import GridItem from './GridItem';
import {MediaContext} from '../../MediaContext';

const MediaGrid = () => {
  const intl = useIntl();
  const mediaContext = useContext(MediaContext);
  const {mediaList, loading} = mediaContext;

  return (
    <AppGrid
      itemPadding={8}
      delay={200}
      responsive={{
        xs: 1,
        sm: 2,
        xxl: 3,
      }}
      data={mediaList}
      renderItem={(item) => <GridItem item={item} key={item.id} />}
      ListEmptyComponent={
        <ListEmptyResult
          content={intl.messages['common.noRecordFound']}
          loading={loading}
        />
      }
    />
  );
};
export default MediaGrid;
